import React from "react";
import { Link } from "react-router-dom";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import SearchOffOutlinedIcon from "@mui/icons-material/SearchOffOutlined";
import Seo from "../../components/seo";
import "./NotFoundPage.css";

export default function NotFoundPage() {
  return (
    <main className="not-found-page">
      <Seo
        title="Page introuvable | Bio-Technofix"
        description="La page demandée est introuvable. Retrouvez les produits et services Bio-Technofix depuis la page d'accueil."
        noindex
      />

      <section className="not-found-card" aria-labelledby="not-found-title">
        <div className="not-found-icon" aria-hidden="true">
          <SearchOffOutlinedIcon />
        </div>
        <p className="not-found-code">Erreur 404</p>
        <h1 id="not-found-title">Cette page est introuvable</h1>
        <p className="not-found-message">
          L’adresse est peut-être incorrecte, ou la page que vous recherchez a
          été déplacée.
        </p>

        <div className="not-found-actions">
          <Link className="not-found-primary-action" to="/home">
            <HomeOutlinedIcon aria-hidden="true" />
            Retour à l’accueil
          </Link>
          <Link className="not-found-secondary-action" to="/contact/us">
            Nous contacter
          </Link>
        </div>
      </section>
    </main>
  );
}
